import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../../data/store";

export const FeaturedProducts = () => {
  return (
    <section
      id="productos"
      data-testid="products-section"
      className="relative py-24 md:py-36 bg-[#0A0908]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-16 flex items-end justify-between flex-wrap gap-6"
        >
          <div>
            <p className="text-xs md:text-sm uppercase tracking-[0.4em] text-[#A66E38] mb-4 flex items-center gap-3">
              <span className="h-px w-8 bg-[#A66E38]" /> Colección
            </p>
            <h2 className="font-serif text-4xl md:text-6xl font-black tracking-tight text-[#F5F0E6] leading-[0.95] max-w-xl">
              Lo que encontrarás en la{" "}
              <span className="italic text-[#C89B3C]">tienda</span>.
            </h2>
          </div>
          <p className="text-sm uppercase tracking-[0.3em] text-[#8A7D71]">
            04 categorías
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {PRODUCTS.map((p, i) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ y: -6 }}
              data-testid={`product-card-${p.id}`}
              className="group relative bg-[#12100E] border border-white/5 hover:border-[#A66E38]/60 transition-all duration-500 overflow-hidden"
            >
              <div className="relative h-80 overflow-hidden">
                {/* radial spotlight on hover */}
                <div className="absolute inset-0 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-[radial-gradient(circle_at_50%_50%,rgba(200,155,60,0.25),transparent_65%)] pointer-events-none" />
                <img
                  src={p.image}
                  alt={p.name}
                  className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0908] via-[#0A0908]/40 to-transparent opacity-90 group-hover:opacity-60 transition-opacity duration-500" />

                <span className="absolute top-4 left-4 z-20 text-xs uppercase tracking-[0.35em] text-[#C89B3C]">
                  0{i + 1}
                </span>
                <span className="absolute top-4 right-4 z-20 text-[#0A0908] bg-[#C89B3C] p-2 opacity-0 -translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                  <ArrowUpRight size={18} />
                </span>
              </div>
              <div className="p-6 md:p-7">
                <p className="text-[0.65rem] uppercase tracking-[0.35em] text-[#A66E38] mb-2">
                  {p.tagline}
                </p>
                <h3 className="font-serif text-2xl md:text-3xl font-semibold text-[#F5F0E6] mb-2">
                  {p.name}
                </h3>
                <p className="text-sm font-light text-[#B8A99A] leading-relaxed">
                  {p.description}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
